import { Alert as MuiAlert, Button, Collapse, Grid, IconButton } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { GridSpg, TextSection, useAsyncCall } from "@duosoftbg/nacid-components";
import { clearNomenclaturesCache, clearKeycloakCache } from "../../../../axios/api/services";
import {
  axiosClientCore,
  axiosClientServices,
  axiosClientPortal,
  axiosClientRegisters,
} from "@duosoftbg/nacid-frontoffice-components";
import { useEffect, useState } from "react";
import { Close } from "@mui/icons-material";
import styled from "styled-components";

const Alert = styled(MuiAlert)`
  .MuiAlert-message {
    width: 100%;
    text-align: center;
  }
  .MuiPaper-root !important; {
    background: #eee;
  }
`;

const clientsArray = [
  { name: "registers", client: axiosClientRegisters },
  { name: "services", client: axiosClientServices },
  { name: "portal", client: axiosClientPortal },
  { name: "core", client: axiosClientCore },
];

const Cache = () => {
  const { asyncCall } = useAsyncCall();
  const { t } = useTranslation();
  const [result, setResult] = useState([]);

  const handleClearNomenclatureCache = () => {
    setResult([]);
    clientsArray.forEach((e) => {
      asyncCall({
        processResponseErrors: false,
        promise: clearNomenclaturesCache(e.client),
        onSuccess: () => {
          setResult((prevState) => [...prevState, ...[{ key: e.name, show: true, isSuccessful: true }]]);
        },
        onError: () => {
          setResult((prevState) => [...prevState, ...[{ key: e.name, show: true, isSuccessful: false }]]);
        },
      });
    });
  };

  const handleClearAbdocsCache = () => {
    setResult([]);
    asyncCall({
      processResponseErrors: false,
      promise: clearKeycloakCache(),
      onSuccess: () => {
        setResult((prevState) => [...prevState, ...[{ key: "keycloak", show: true, isSuccessful: true }]]);
      },
      onError: () => {
        setResult((prevState) => [...prevState, ...[{ key: "keycloak", show: true, isSuccessful: false }]]);
      },
    });
  };

  return (
    <>
      <Result result={result} />
      <Grid container spacing={1}>
        <GridSpg item xs={12} textAlign={"center"} mt={0}>
          <div style={{ marginTop: "-16px" }}>
            <TextSection label={"Номенклатури"}>
              <Button
                onClick={handleClearNomenclatureCache}
                size={"small"}
                type={"button"}
                variant="contained"
                color="info"
              >
                {t("Изчистване")}
              </Button>
            </TextSection>
          </div>
        </GridSpg>
        <GridSpg item xs={12} textAlign={"center"}>
          <div>
            <TextSection label={"Keycloak"}>
              <Button onClick={handleClearAbdocsCache} size={"small"} type={"button"} variant="contained" color="info">
                {t("Изчистване")}
              </Button>
            </TextSection>
          </div>
        </GridSpg>
      </Grid>
    </>
  );
};

const Result = ({ result }) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    let some = result.some((e) => e.show);
    setOpen(some);
  }, [result]);

  return (
    <Collapse in={open}>
      <Alert
        severity={"info"}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
            }}
          >
            <Close fontSize="inherit" />
          </IconButton>
        }
        sx={{ mb: 2 }}
      >
        {result.map((e) => (
          <div key={e.key} style={{ color: e.isSuccessful ? "green" : "red", fontWeight: "bold" }}>
            {t(`t.module.${e.key}`)} - {e.isSuccessful ? t("l.yes") : t("l.no")}
          </div>
        ))}
      </Alert>
    </Collapse>
  );
};
export default Cache;
